/**
 * Client-side NPI format + Luhn checks — the instant, no-network first pass.
 *
 * Mirrors the backend `modules.platform.npi.format`. A valid format/checksum
 * says nothing about individual (NPI-1) vs organization (NPI-2); only the
 * server's NPPES lookup distinguishes those.
 */

const NPI_PREFIX = '80840';
const NPI_FORMAT = /^[12]\d{9}$/;

export function isValidNpiFormat(npi: string): boolean {
  return NPI_FORMAT.test(npi);
}

function luhnCheckDigit(prefixed: string): number {
  let total = 0;
  const digits = prefixed.split('').reverse();
  for (let i = 0; i < digits.length; i++) {
    let d = Number(digits[i]);
    if (i % 2 === 0) {
      d *= 2;
      if (d > 9) d -= 9;
    }
    total += d;
  }
  return (10 - (total % 10)) % 10;
}

export function isValidNpi(npi: string): boolean {
  if (!isValidNpiFormat(npi)) return false;
  return luhnCheckDigit(NPI_PREFIX + npi.slice(0, 9)) === Number(npi[9]);
}
